module.exports = __webpack_public_path__ + "static/media/pantallas@2x.a453549f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/pantallas@2x.png
// module id = 64
// module chunks = 0